module.exports = __webpack_public_path__ + "img/材料力学6_1_1.bdecaf98.jpg";